export default {
  en: {
    'components.multi-selector.actions.select': 'Select:',
    'components.multi-selector.actions.all': 'All',
    'components.multi-selector.actions.none': 'None',
  },
};
